import {SecureService} from "@/services/superclasses/secure-service";
import {PriceUnit} from "@/interfaces/price-unit";

const api = window.contextPath + '/rest/price-units';

export class PriceUnitSecureService extends SecureService {

    public loadAll = async (type: Array<number>): Promise<PriceUnit[]> => {
        return this.data(await this.get<PriceUnit[]>(api,
            {
                params: {
                    type
                }
            }))
    }
}

export const priceUnitSecureService = new PriceUnitSecureService()